export default "__VITE_ASSET__BxBpqdWq__"